import type { Voice } from "./db";

export class TtsError extends Error {
  constructor(message: string, public readonly status?: number) {
    super(message);
    this.name = "TtsError";
  }
}

/**
 * Requests generated speech audio for one chunk of text. Throws TtsError on
 * failure so callers can retry without losing document position.
 */
export async function synthesizeChunk(text: string, voice: Voice, signal?: AbortSignal): Promise<Blob> {
  const res = await fetch("/api/tts", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text, speaker: voice }),
    signal,
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => "");
    throw new TtsError(`TTS request failed (${res.status}): ${detail.slice(0, 200)}`, res.status);
  }

  const blob = await res.blob();
  if (blob.size === 0) {
    throw new TtsError("TTS returned empty audio");
  }
  return blob;
}
